export default "__VITE_ASSET__Dv$yRdnJ__"